import React from 'react'
import { ViewStyle } from 'react-native'

import styled from 'styled-components/native'

type MessengerUtilityItemHeaderProps = React.PropsWithChildren<{
  style?: ViewStyle
  showDivider?: boolean
}>

const Header = styled.View<{ showDivider?: boolean }>(({ theme, showDivider }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  height: '75px',
  padding: `0px ${theme.spacing['16px']}`,
  backgroundColor: theme.colors.backgroundPrimary,
  ...(showDivider
    ? {
        borderBottomWidth: '1px',
        borderBottomColor: theme.colors.borderDefault,
      }
    : {}),
}))
const MessengerUtilityItemHeader: React.FC<MessengerUtilityItemHeaderProps> = ({
  style,
  children,
  showDivider = true,
}) => {
  return (
    <Header style={style} showDivider={showDivider}>
      {children}
    </Header>
  )
}

export default MessengerUtilityItemHeader
